import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { pageMetadata, defaultMetadata } from '../constants/pageMetadata';

/**
 * Helper function to match current pathname against React Router-style patterns.
 * e.g., '/transport-profile/:id' matches '/transport-profile/12345'
 */
const matchRoute = (pattern, pathname) => {
  const regexPattern = '^' + pattern
    .replace(/:[a-zA-Z0-9_]+/g, '[^/]+')
    .replace(/\*/g, '.*') + '$';
  const regex = new RegExp(regexPattern);
  return regex.test(pathname);
};

/**
 * useDocumentMetadata
 * 
 * Automatically synchronizes document title and meta description with the active route.
 */
export const useDocumentMetadata = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    let matched = null;

    // Find first matching route pattern
    for (const pattern of Object.keys(pageMetadata)) {
      if (matchRoute(pattern, pathname)) {
        matched = pageMetadata[pattern];
        break;
      }
    }

    const title = matched ? matched.title : defaultMetadata.title;
    const description = matched ? matched.description : defaultMetadata.description;

    // 1. Update title tag
    document.title = title;

    // 2. Update meta description tag
    let metaDescription = document.querySelector('meta[name="description"]');
    if (!metaDescription) {
      metaDescription = document.createElement('meta');
      metaDescription.setAttribute('name', 'description');
      document.head.appendChild(metaDescription);
    }
    metaDescription.setAttribute('content', description);
  }, [pathname]);
};
